import type { NodeTypes } from "@xyflow/react";

import PlaygroundInputNode from "./PlaygroundInputNode";
import PlaygroundAgentNode from "./PlaygroundAgentNode";
import PlaygroundTeamNode from "./PlaygroundTeamNode";
import PlaygroundToolNode from "./PlaygroundToolNode";
import PlaygroundOutputNode from "./PlaygroundOutputNode";

export const playgroundNodeTypes: NodeTypes = {
  input: PlaygroundInputNode,
  agent: PlaygroundAgentNode,
  team: PlaygroundTeamNode,
  tool: PlaygroundToolNode,
  output: PlaygroundOutputNode,
};

export {
  PlaygroundInputNode,
  PlaygroundAgentNode,
  PlaygroundTeamNode,
  PlaygroundToolNode,
  PlaygroundOutputNode,
};
export { StatusBadge } from "./StatusBadge";
